export default __webpack_public_path__ + "static/media/venue.877b6fe9.jpg";